import * as React from 'react';

var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLocationMapOutline24 = function SvgLocationMapOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 24 25",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.248 10.79-6.235 9.325c-.423-.62-1.839-2.69-3.223-4.734-.738-1.089-1.465-2.17-2.029-3.02-.282-.424-.522-.79-.701-1.07a8.8 8.8 0 0 1-.317-.515l-.448.222.448-.221a7.167 7.167 0 0 1 1.312-8.204 6.932 6.932 0 0 1 9.889 0 7.16 7.16 0 0 1 1.305 8.217zm-5.881 9.694-.188-.128z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15.65c4.896.459 8.5 2.014 8.5 3.862 0 2.21-5.149 4-11.5 4s-11.5-1.79-11.5-4c0-1.848 3.604-3.403 8.5-3.862"
  }))));
};

var LocationMapOutline24Svg = SvgLocationMapOutline24;

export { LocationMapOutline24Svg as default };
//# sourceMappingURL=LocationMapOutline24.svg.js.map
